import { render, staticRenderFns } from "./terceiros.vue?vue&type=template&id=ecef6b44&"
import script from "./terceiros.vue?vue&type=script&lang=js&"
export * from "./terceiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports